export const APP_TITLE_BAR_HEADING_SECTION_ELEMENT_ID = 'app-title-bar-heading-section-element'
export const APP_TITLE_BAR_RIGHT_BUTTONS_SECTION_ELEMENT_ID = 'app-title-bar-right-buttons-section-element'
